import React from 'react';

const OptionsScreen = ({ onNavigate }) => {
  const handleOptionClick = (option) => {
    onNavigate(option);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    window.location.reload();
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #CAE0BC 0%, #EAFAEA 100%)',
      fontFamily: 'Arial, sans-serif',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '500px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ 
            marginBottom: '10px',
            width: '120px',
            height: '120px',
            borderRadius: '12px',
            backgroundColor: 'rgba(108, 139, 88, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(108, 139, 88, 0.2)'
          }}>
            <img 
              src="/zzf.png" 
              alt="ZZF Logo" 
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'contain'
              }}
            />
          </div>
          <h1 style={{ 
            margin: 0, 
            fontSize: '2rem',
            background: 'linear-gradient(135deg, #6C8B58, #8BA888)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold'
          }}>ZZF</h1>
          <p style={{ 
            color: '#666', 
            margin: '10px 0 0 0',
            fontSize: '1.1rem'
          }}>Odaberite opciju</p>
        </div>

        {/* Options */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Preuzimanje vozila */}
          <button
            onClick={() => handleOptionClick('pickup')}
            style={{
              width: '100%',
              padding: '25px',
              background: '#7B9C92',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 8px 20px rgba(123, 156, 146, 0.3)',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 12px 25px rgba(123, 156, 146, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 20px rgba(123, 156, 146, 0.3)';
            }}
          >
            <span>Preuzimanje vozila</span>
          </button>

          {/* Vraćanje vozila */}
          <button
            onClick={() => handleOptionClick('return')}
            style={{
              width: '100%',
              padding: '25px',
              background: '#434824',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 8px 20px rgba(67, 72, 36, 0.3)',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 12px 25px rgba(67, 72, 36, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 20px rgba(67, 72, 36, 0.3)';
            }}
          >
            <span>Vraćanje vozila</span>
          </button>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '15px',
              background: 'rgba(220, 53, 69, 0.1)',
              color: '#dc3545',
              border: '2px solid #dc3545',
              borderRadius: '15px',
              fontSize: '1rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              marginTop: '10px'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#dc3545';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'rgba(220, 53, 69, 0.1)';
              e.target.style.color = '#dc3545';
            }}
          >
            Odjavi se
          </button>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <p style={{ color: 'rgba(108, 139, 88, 0.7)', fontSize: '12px', margin: 0 }}>
            © 2025 ZZF - Zavod za fotogrametriju d.d.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OptionsScreen;
